// extracted by mini-css-extract-plugin
export var addressFields = "_mf-0";
export var animationContainer = "_mf-1";
export var footer = "_mf-2";
export var lineItems = "_mf-3";
export var modalContent = "_mf-4";
export var orderName = "_mf-5";
export var strong = "_mf-6";
export var warning = "_mf-7";